import React from 'react';
import { Box, Flex, Heading } from '@chakra-ui/react';

export const Panel = ({ title, action, children, ...rest }) => (
    <Box
        bg="surface"
        border="1px solid"
        borderColor="borderPrimary"
        borderRadius="xl"
        p={5}
        {...rest}
    >
        {title && (
            <Flex align="center" justify="space-between" mb={4} pb={3} borderBottom="1px solid" borderColor="borderPrimary">
                <Heading
                    as="h3"
                    size="sm"
                    textTransform="uppercase"
                    letterSpacing="1.5px"
                    color="textPrimary"
                    fontWeight="800"
                >
                    {title}
                </Heading>
                {action}
            </Flex>
        )}
        {children}
    </Box>
);

export const KpiCard = ({ label, value, hint, accent = '#02EA75' }) => (
    <Box
        bg="surface"
        borderRadius="xl"
        p={5}
        position="relative"
        overflow="hidden"
        border="1px solid"
        borderColor="borderPrimary"
        _before={{
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            w: '4px',
            bg: accent,
        }}
    >
        <Box fontSize="2.2rem" fontWeight="900" color="textPrimary" lineHeight="1">
            {value}
        </Box>
        <Box fontSize="0.65rem" fontWeight="700" textTransform="uppercase" color="textSecondary" mt={2} letterSpacing="1px">
            {label}
        </Box>
        {hint && (
            <Box fontSize="0.65rem" color="textSecondary" mt={1}>
                {hint}
            </Box>
        )}
    </Box>
);
